import {useCallback} from 'react';

import _ from 'topmeteo/utils/i18n';

const HelpText = _('To add new locations (via name or coordinates), please use the <i>SEARCH BAR</i>.');

const LocationManagerHelpText = ({onClose}) => {
    const handleClick = useCallback(
        event => {
            const locationSearchNode = document.getElementById('location-search');
            const inputNode = locationSearchNode.getElementsByClassName('form-element')[0];

            inputNode.focus();

            return onClose(event);
        },
        [onClose],
    );

    return (
        <p
            className="help-text"
            dangerouslySetInnerHTML={{__html: HelpText}}
            onClick={handleClick}
        />
    );
};

export default LocationManagerHelpText;
